import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchPublicGame, getFullCoverUrl } from '../api/games';
import { formatText } from '../utils/typografUtils';
import '../components/GameDetailsOverlay/GameDetailsOverlay.css';

export default function SharedGamePage() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [game, setGame] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const loadGame = async () => {
            try {
                const data = await fetchPublicGame(slug);
                if (!isMounted) return;

                if (!data) {
                    setError('Игра не найдена');
                    setLoading(false);
                    return;
                }

                setGame({
                    id: data.id,
                    title: data.title,
                    subtitle: data.subtitle,
                    description: data.description,
                    coverUrl: getFullCoverUrl(data.cover_path),
                    slug: data.slug
                });
                setLoading(false);
            } catch (err) {
                if (isMounted) {
                    console.error('Error loading game:', err);
                    setError('Не удалось загрузить игру');
                    setLoading(false);
                }
            }
        };

        loadGame();

        return () => {
            isMounted = false;
        };
    }, [slug]);

    const handleGetGame = () => {
        navigate('/');
    };

    if (loading) {
        return (
            <div className="overlay" role="dialog" aria-label="Загрузка игры">
                <div className="overlay-content">
                    <div className="overlay-body">
                        <div className="overlay-scroll" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50vh' }}>
                            <div className="payment-spinner"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !game) {
        return (
            <div className="overlay" role="dialog" aria-label="Ошибка">
                <div className="overlay-content">
                    <div className="overlay-body">
                        <div className="overlay-scroll" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: '16px' }}>
                            <div style={{ fontSize: '48px' }}>😕</div>
                            <p className="overlay-text" style={{ textAlign: 'center' }}>{error || 'Игра не найдена'}</p>
                            <button className="tab-btn-accent-large" onClick={handleGetGame}>
                                На главную
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="overlay" role="dialog" aria-modal="true" aria-label={`Описание игры ${game.title}`}>
            <div
                className="overlay-bg overlay-bg--current"
                aria-hidden="true"
                style={{ backgroundImage: `url(${game.coverUrl})` }}
            />
            <div className="overlay-content">
                <div className="overlay-body">
                    <div className="overlay-scroll">
                        <div className="game-hero-wrap">
                            <img className="game-hero" src={game.coverUrl} alt={game.title} />
                        </div>
                        <h2 className="overlay-title">{formatText(game.title)}</h2>
                        {game.subtitle && <div className="overlay-subtitle">{formatText(game.subtitle)}</div>}

                        {game.description && (
                            <p className="overlay-text">{formatText(game.description)}</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="tabbar-wrap">
                <button className="tab-btn-accent-large tab-btn-accent-full" aria-label="Получить игру" onClick={handleGetGame}>
                    <span className="tab-btn-accent-large-icon">
                        <img src="/icons/get-demo.svg" alt="" aria-hidden="true" />
                    </span>
                    Получить игру
                </button>
            </div>
        </div>
    );
}
